export default __webpack_public_path__ + "static/media/HASSAN_FR_INTRO.2f1561f1.mp3";